import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/projectCategory.service';
import PreviewImage from '../../components/previewImage';
import gc from '../../components/cms/gridComponents';

const getColumns = t => [
  {
    name: 'title',
    title: t('Title'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.title}</Link>),
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color="secondary">
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypeOptions(t)),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

export default getColumns;



// WEBPACK FOOTER //
// ./src/views/project-categories/getColumns.js